import { EntityStatusDesc } from '../../../models/entity.model'
import { ReplenishmentStatus } from '../models/replenishment.types'

export const REPLENISHMENT_STATUSES: EntityStatusDesc<ReplenishmentStatus>[] = [
  {
    code: 'PENDING',
    name: 'Pending',
    primary: true,
    tooltip: 'Replenishment waiting for operator',
  },
  {
    code: 'PROCESSING',
    name: 'PROCESSING',
    primary: true,
    tooltip: 'Replenishment being managed by an operator',
  },
  {
    code: 'COMPLETED',
    name: 'Completed',
    primary: true,
    tooltip: 'Replenishment completed by an operator',
  },
  {
    code: 'CANCELED',
    name: 'CANCELED',
    primary: false,
    tooltip: 'Replenishment canceled',
  },
]
